import { ComposerTikTokPostOptions } from 'components/Composer/CustomizePostBlock/TikTokOptions'
import { Fragment, useCallback, useMemo } from 'react'
import { TikTokPostProfileSettings, TikTokPrivacyOptions } from 'shared'
import { ComposerTikTokPost } from 'shared/types'
import styles from '../BulkPost.pcss'
import { BulkNetworkOptionsProps } from './types'

export function TikTokBulkOptions(props: BulkNetworkOptionsProps) {
  const { post, tiktokData, recycleSelector, onTikTokSettingsChange } = props

  const tiktokOptions = useMemo(() => Object.keys(tiktokData || {}).reduce((acc, ppid) => {
    acc[ppid] = tiktokData![ppid].options
    return acc
  }, {} as Record<string, TikTokPrivacyOptions>), [tiktokData])

  const tiktokSavedRecords = useMemo(() => Object.keys(tiktokData || {}).reduce((acc, ppid) => {
    acc[ppid] = tiktokData![ppid].hasSavedSettings
    return acc
  }, {} as Record<string, boolean>), [tiktokData])

  const handleSettingsChange = useCallback((settings: TikTokPostProfileSettings) => {
    onTikTokSettingsChange(post.id, settings)
  }, [onTikTokSettingsChange, post.id])

  return (
    <Fragment>
      <div className={styles.option}>{recycleSelector}</div>
      <div className={styles.option}>
        <ComposerTikTokPostOptions
          isPhotoPost={Boolean(post.imageUrl)}
          popupMode
          singleAction
          actionsClassName={styles['tk-actions']}
          settings={(post.data as ComposerTikTokPost).settings}
          options={tiktokOptions}
          hasSavedSettings={tiktokSavedRecords}
          skipFetchSettings
          onChange={handleSettingsChange}
        />
      </div>
    </Fragment>
  )
}
